import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class Careers extends Component {
  state = {
    careers: [],
    formData: {
      id: null,
      admin_id: "",
      career_title: "",
      career_description: "",
      career_location: "",
      career_salary: "",
      career_deadline: "",
      career_status: "1",
      career_date: "",
    },
    deleteId: null,
    error: "",
    loading: false,
    submitting: false,
    modalMode: "add",
  };

  componentDidMount() {
    this.fetchCareers();

    const modalEl = document.getElementById("careerModal");
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", () => {
        this.resetForm();
      });
    }
  }

  /** ✅ Fetch all careers */
  fetchCareers = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get("/careers", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data?.data || [];
      this.setState({ careers: Array.isArray(data) ? data : [] });
    } catch (err) {
      this.setState({
        error:
          err.response?.data?.message ||
          "Failed to load careers. Please try again.",
      });
    } finally {
      this.setState({ loading: false });
    }
  };

  /** ✅ Reset form */
  resetForm = () => {
    this.setState({
      formData: {
        id: null,
        admin_id: "",
        career_title: "",
        career_description: "",
        career_location: "",
        career_salary: "",
        career_deadline: "",
        career_status: "1",
        career_date: "",
      },
      error: "",
      submitting: false,
      modalMode: "add",
    });
  };

  /** ✅ Input change */
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      formData: {
        ...prev.formData,
        [name]: value,
      },
    }));
  };

  /** ✅ Open modal */
  openModal = (mode = "add", career = null) => {
    const modal = new window.bootstrap.Modal(
      document.getElementById("careerModal")
    );

    if (mode === "edit" && career) {
      this.setState({
        modalMode: "edit",
        formData: {
          id: career.id,
          admin_id: career.admin_id || "",
          career_title: career.career_title || "",
          career_description: career.career_description || "",
          career_location: career.career_location || "",
          career_salary: career.career_salary || "",
          career_deadline: career.career_deadline || "",
          career_status: career.career_status?.toString() ?? "1",
          career_date: career.career_date || "",
        },
        error: "",
      });
    } else {
      this.resetForm();
    }

    modal.show();
  };

  /** ✅ Submit add/update */
  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData, modalMode } = this.state;

    if (!formData.admin_id) {
      return this.setState({ error: "Admin Name is required." });
    }
    if (!formData.career_title) {
      return this.setState({ error: "Career title is required." });
    }
    if (!formData.career_deadline) {
      return this.setState({ error: "Career deadline is required." });
    }
    if (formData.career_status === "") {
      return this.setState({ error: "Status is required." });
    }

    const data = new FormData();
    data.append("admin_id", formData.admin_id);
    data.append("career_title", formData.career_title);
    data.append("career_description", formData.career_description);
    data.append("career_location", formData.career_location);
    data.append("career_salary", formData.career_salary);
    data.append("career_deadline", formData.career_deadline);
    data.append("career_status", formData.career_status);
    data.append("career_date", formData.career_date);

    this.setState({ submitting: true, error: "" });

    try {
      const token = localStorage.getItem("token");

      if (modalMode === "add") {
        await axios.post("/careers", data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      } else {
        await axios.post(`/careers/${formData.id}?_method=PUT`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });
      }

      await this.fetchCareers();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("careerModal")
      );
      if (modal) modal.hide();

      Swal.fire({
        icon: "success",
        title:
          modalMode === "add"
            ? "Career added successfully!"
            : "Career updated successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        error:
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Error saving career.",
      });
    } finally {
      this.setState({ submitting: false });
    }
  };

  /** ✅ Confirm delete */
  confirmDelete = (id) => {
    this.setState({ deleteId: id });
    const modal = new window.bootstrap.Modal(
      document.getElementById("deleteModal")
    );
    modal.show();
  };

  /** ✅ Delete career */
  handleDelete = async () => {
    const { deleteId } = this.state;
    if (!deleteId) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`/careers/${deleteId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await this.fetchCareers();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("deleteModal")
      );
      if (modal) modal.hide();

      Swal.fire({
        icon: "success",
        title: "Career deleted successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Failed to delete career.",
      });
    }
  };

  render() {
    const {
      careers,
      formData,
      error,
      loading,
      submitting,
      modalMode,
    } = this.state;

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-lg-12">
              <div className="card shadow-none">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <ul className="breadcrumb mb-0">
                    <li className="breadcrumb-item">Careers</li>
                    <li className="breadcrumb-item active">List</li>
                  </ul>

                  <button
                    type="button"
                    className="btn btn-light-warning"
                    onClick={() => this.openModal("add")}
                  >
                    + New Career
                  </button>
                </div>

                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}

                  {loading ? (
                    <div className="text-center py-4">Loading...</div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Admin Name</th>
                            <th>Career Title</th>
                            <th>Location</th>
                            <th>Salary</th>
                            <th>Deadline</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {careers.length > 0 ? (
                            careers.map((career, index) => (
                              <tr key={career.id}>
                                <td>{index + 1}</td>
                                <td>{career.admin_id}</td>
                                <td>{career.career_title}</td>
                                <td>{career.career_location || "N/A"}</td>
                                <td>{career.career_salary || "N/A"}</td>
                                <td>{career.career_deadline || "N/A"}</td>
                                <td>
                                  {career.career_status === "1" ||
                                  career.career_status === 1 ? (
                                    <span className="badge bg-success">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="badge bg-danger">
                                      Inactive
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-light-success me-2"
                                    onClick={() =>
                                      this.openModal("edit", career)
                                    }
                                  >
                                    <i className="ph ph-note-pencil"></i>
                                  </button>

                                  <button
                                    className="btn btn-sm btn-light-danger"
                                    onClick={() =>
                                      this.confirmDelete(career.id)
                                    }
                                  >
                                    <i className="ph ph-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No careers found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add / Edit Modal */}
        <div className="modal fade" id="careerModal" tabIndex={-1}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <form onSubmit={this.handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    {modalMode === "add" ? "Add Career" : "Edit Career"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="row">
                    {/* Admin ID */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Admin Name</label>
                      <input
                        type="text"
                        name="admin_id"
                        className="form-control"
                        value={formData.admin_id}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    {/* Career Title */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Career Title</label>
                      <input
                        type="text"
                        name="career_title"
                        className="form-control"
                        value={formData.career_title}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    {/* Career Location */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Location</label>
                      <input
                        type="text"
                        name="career_location"
                        className="form-control"
                        value={formData.career_location}
                        onChange={this.handleChange}
                      />
                    </div>

                    {/* Career Salary */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Salary</label>
                      <input
                        type="text"
                        name="career_salary"
                        className="form-control"
                        value={formData.career_salary}
                        onChange={this.handleChange}
                      />
                    </div>

                    {/* Career Deadline */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Deadline</label>
                      <input
                        type="date"
                        name="career_deadline"
                        className="form-control"
                        value={formData.career_deadline}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    {/* Career Status */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Status</label>
                      <select
                        name="career_status"
                        className="form-select"
                        value={formData.career_status}
                        onChange={this.handleChange}
                        required
                      >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>

                    {/* Career Description */}
                    <div className="col-md-12 mb-3">
                      <label className="form-label">Career Description</label>
                      <textarea
                        name="career_description"
                        className="form-control"
                        rows="5"
                        value={formData.career_description}
                        onChange={this.handleChange}
                      ></textarea>
                    </div>

                    {error && (
                      <div className="col-md-12">
                        <div className="alert alert-danger">{error}</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light-danger"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-light-primary"
                    disabled={submitting}
                  >
                    {submitting
                      ? "Saving..."
                      : modalMode === "add"
                      ? "Add"
                      : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Delete Modal */}
        <div className="modal fade" id="deleteModal" tabIndex={-1}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-danger">
              <div className="modal-body text-center p-4">
                <i className="ph ph-warning text-danger f-40 mb-3"></i>
                <h5>Are you sure?</h5>
                <p className="text-muted mb-4">This action cannot be undone.</p>

                <div className="d-flex justify-content-center gap-3">
                  <button
                    type="button"
                    className="btn btn-light-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-light-danger"
                    onClick={this.handleDelete}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Careers;
